import { unwrapResult } from '@reduxjs/toolkit';
import Loading from 'components/Loading';
import { INIT_PAGINATION } from 'constants/common.constant';
import { getUniqueKey } from 'helpers/common.helper';
import { IQueryParam } from 'interfaces/common.interface';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getBeamPhotoGroups } from 'store/global/action';
import { useAppDispatch } from 'store/hooks';

const Feed = () => {
  const dispatch = useAppDispatch();

  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<IQueryParam>({
    page: INIT_PAGINATION.PAGE,
    limit: INIT_PAGINATION.LIMIT,
  });
  const [pagination, setPagination] = useState<any>(null);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      const res: any = await unwrapResult(
        await dispatch(getBeamPhotoGroups(params)),
      );

      if (res && res.items && res.pagination) {
        setData([...data, ...res.items]);
        setPagination(res.pagination);
      } else {
        setData([...[]]);
        setPagination(null);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchMoreData = () => {
    if (params.page && params.page < pagination.totalPages) {
      setParams({ ...params, page: params.page + 1 });
    }
  };

  useEffect(() => {
    if (params) {
      fetchData();
    }
  }, [params]);

  useEffect(() => {
    if (pagination) {
      if (pagination.currentPage < pagination.totalPages) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    }
  }, [pagination]);

  return (
    <div className="content">
      {data.length > 0 && (
        <div className="px-0 lg:px-[1.875rem]">
          <div>
            <InfiniteScroll
              dataLength={data.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<Loading />}
              endMessage={
                <p className="all-items-txt">You have seen all items</p>
              }
            >
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 py-4">
                {data.map((item) => (
                  <div
                    key={getUniqueKey()}
                    className="flex flex-col items-center justify-center gap-2"
                  >
                    <div className="w-full">
                      <p className="mb-0 flex items-center gap-2 text-[0.8rem]">
                        {item.data[0].createdBy ? (
                          <a
                            target="_blank"
                            href={`/user/${item.data[0].createdBy._id}`}
                          >
                            {item.data[0].createdBy.fullName}
                          </a>
                        ) : (
                          '_'
                        )}
                        <span>
                          {item.data[0].createdAt
                            ? moment(item.data[0].createdAt).format(
                                'YYYY-MM-DD HH:mm:ss',
                              )
                            : '_'}
                        </span>
                      </p>
                    </div>

                    <a
                      className="w-full"
                      target="_blank"
                      href={`/user/${item.data.at(-1).createdBy._id}?anchor=${item.data.at(-1)._id}`}
                    >
                      <div
                        className="w-full aspect-square bg-cover bg-center rounded overflow-hidden transition-transform duration-300 hover:scale-105"
                        style={{
                          backgroundImage: `url(${item.thumbnail?.medium || ''})`,
                        }}
                      ></div>
                    </a>
                  </div>
                ))}
              </div>
            </InfiniteScroll>
          </div>
        </div>
      )}
    </div>
  );
};

export default Feed;
